import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        displaySize: {
            type: 'desktop',
            height: '',
            width: ''
        },
        title: '',
        componentSteps: 0,
        currentStep:'',
        teamPlayer: [],
        editPlayerSteps:[],
        allPlayerSteps:[],
        choicePlayerSteps: [],
        compositions: [],
        choicesPlayer: [],
        taggage:{}
    },
    getters: {
        getDisplayType: state => {
            return state.displaySize.type;
        },
        getDisplayHeightSize: state => {
            return state.displaySize.height;
        },
        getDisplayWidthSize: state => {
            return state.displaySize.width;
        },
        getTitle : state => {
            return state.title;
        },
        getComponentSteps: state => {
            return state.componentSteps;
        },
        getTranings: state => {
            return state.tranings[0];
        },
        getTraningChoice: state => {
            return state.traningChoice;
        },
        getTeamPlayer: state => {
            return state.teamPlayer;
        },
        getChoicesPlayer: state => {
            return state.choicesPlayer;
        },
        getChoicePlayerSteps: state => {
            return state.choicePlayerSteps;
        },
        getCurrentStep: state => {
            return state.currentStep;
        },
        getAllPlayertSteps: state => {
            return state.allPlayerSteps;
        },
        getEditPlayertSteps: state => {
            return state.editPlayerSteps;
        },
        getComposition : state => {
            return state.compositions;
        },
        getTaggage: state => {
            return state.taggage
        }
    },
    mutations: {
        CHANGE_DISPLAY(state, newSize) {
            state.displaySize = newSize;
        },
        ADD_TITLE(state, title){
            state.title = title;
        },
        NEW_STEPS(state) {
            state.componentSteps++;
            if(state.componentSteps > 0){
                state.currentStep = state.editPlayerSteps.shift();
                state.choicePlayerSteps.push(state.currentStep);
            }
        },
        ADD_STEPS_PLAYER(state, steps) {
            state.allPlayerSteps = steps;
            state.editPlayerSteps= state.allPlayerSteps.slice(0);
        },
        RESET_STEPS(state,step) {
            state.componentSteps = step;
            state.choicesPlayer = [];
            state.choicePlayerSteps = [];
            state.editPlayerSteps = [];
            state.editPlayerSteps = state.allPlayerSteps.slice(0);
        },
        ADD_CHOICE_PLAYER(state, {player , position}) {
            state.choicesPlayer[position]=player;
        },
        ADD_TAGGAE(state,taggage){
            state.taggage = taggage;
        },
        ADD_COMPOSITONS(state, composition){
            state.compositions = composition;
        },
        ADD_TEAMPLAYER(state,teamPlayer){
            state.teamPlayer = teamPlayer;
        }

    },
    actions: {
        changeDisplaySize({commit}, newSize) {
            commit('CHANGE_DISPLAY', newSize);
        },
        addTitle({commit}, title){
            commit('ADD_TITLE',title);
        },
        addAllSteps({commit},steps){
            commit('ADD_STEPS_PLAYER',steps);
        },
        addNewSteps({ commit }) {
            commit('NEW_STEPS');
        },
        addChoicePlayer({ commit }, {player, position}) {
            commit('ADD_CHOICE_PLAYER', {player , position});
        },
        resetChoice({commit}){
            commit('RESET_STEPS', 2);
        },
        reset({commit}){
            commit('RESET_STEPS', 0);
        },
        addStepsTaggage({commit},taggage){
            commit('ADD_TAGGAE',taggage);
        },
        addComposition({commit},composition){
            commit('ADD_COMPOSITONS',composition);
        },
        addTeamPlayer({commit},teamPlayer){
            commit('ADD_TEAMPLAYER',teamPlayer);
        }
    }
})